import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CodehelpService } from "virtue-form";
import { AuthService } from "../auth/auth.service";
import { ApiService } from "./api.service";
import { GlobalVarService } from "./global-var.service";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CheckLoginSessionService {
  public sessionStatusSubject = new Subject<any>();
  constructor(
    private authService: AuthService,
    private router: Router,
    private apiservice: ApiService,
    public globalvar: GlobalVarService,
    private codehelp: CodehelpService
  ) {}

  CheckUserSession() {
    if (this.checkAuthTokenSession() == false) {
      return false;
    } else {
      return true;
    }
  }

  checkAuthTokenSession() {
    let TokenAccess = this.codehelp.getAuthToken();
    let sessionToken = this.codehelp.getSessionStoreValue("loginToken"); //Handle morethan one user login

    if (sessionToken == null && TokenAccess) {
      this.codehelp.setSessionStoreValue("loginToken", TokenAccess); //Handle morethan one user login
      return true;
    } else {
      if (sessionToken && TokenAccess != null) {
        if (this.codehelp.getAuthToken() == sessionToken) {
          return true;
        } else {
          if (this.codehelp.getAuthToken() != sessionToken) {
            return true;
          } else {
            this.globalvar.LoginShowPopup = false;
            // this.sessionStatusSubject.next(false);
            return false;
          }
        }
      } else {
        return false;
      }
    }
  }

  checkTop5RequestUserSession() {
    if (this.codehelp.getStoreValue("top5RequestLogin") == "true") {
      return true;
    } else {
      return false;
    }
  }

  clickActionToCheckLogout() {
    if (this.checkAuthTokenSession() == false) {
      // if (this.codehelp.getAuthToken() == null) {
      this.onLogout("");
      return false;
    } else {
      return true;
    }
  }

  onLogout(type: string) {
    if (type == "Manual") {
      this.codehelp.setStoreValue("LoginSessionHoure", "");
      this.codehelp.setStoreValue("top5RequestLogin", "false");
      let TokenAccess = this.codehelp.getAuthToken();
      sessionStorage.removeItem("loginToken");
      this.codehelp.resetUserInfoLogout();
    }

    this.globalvar.ReciprocitySelectedStateList = [];
    this.globalvar.isLoginAsCounselor = undefined;
    this.globalvar.top5SubscriptionDashboardRequestData = undefined;
    this.globalvar.isLoginFromDashboard = undefined;
    this.globalvar.formSubmitId = "";
    this.globalvar.formResponse = undefined;
    this.globalvar.userLoginDetails = "";
    this.globalvar.isLoading = false;
    this.globalvar.isShowLogin = true;
    this.globalvar.submissionReportLink = "";
    this.globalvar.selectedUniversityList = [];
    this.globalvar.seFormFilledId = "";
    this.globalvar.formFilledSubmitID = "";
    this.globalvar.userLoginDetails = "";
    this.clearAllAnswerMaps();
    this.globalvar.isTokenLogin = false;
    this.globalvar.isSelectionByFilters = false;
    this.globalvar.handleSelectionCollege = false;
    this.globalvar.loadOrganization(true, false, false);
    const login = this.codehelp.getStoreValue("LoginUserFrom");
    if (login === "UserLogin") {
      this.router.navigate(["home/login"]);
    } else if (login === "DemoStudent") {
      this.router.navigate(["home/login"]);
    } else if (login === "DemoCounselor") {
      this.router.navigate(["home/login"]);
    } else {
      this.router.navigate(["home/login"]);
    }
    this.reloadPage();
  }

  reloadPage() {
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }

  clearAllAnswerMaps() {
    this.globalvar.answerMap.clear();
    this.globalvar.interestPageAnswerMap.clear();
    this.globalvar.CollegeSelctionList.clear();
    this.globalvar.searchCollegeList.clear();
    this.globalvar.affinityQuestionAnswer.clear();
    this.globalvar.filterSelected.clear();
    this.globalvar.StateInOutMap.clear();
  }
}
